/**
 * A11y helper to trigger click on link element when user clicks anywhere
 * within tile element. Can be used anywhere by adding `js-link-tile` class to
 * outer card element and `js-link-tile-link` to the link to be triggered.
 */
const LinkTile = (function () {
  const initTiles = () => {
    const tileLinkEls = document.querySelectorAll('.js-link-tile')
    tileLinkEls.forEach((tileEl) => {
      tileEl.addEventListener('click', handleTileClick)
    })
  }

  const handleTileClick = (e) => {
    const tileEl = e.target.closest('.js-link-tile')
    if (tileEl) {
      const tileLinkEl = tileEl.querySelector('.js-link-tile__link')
      if (tileLinkEl) {
        // Allow user to open link in new tab if ctrl/cmd button pressed
        if (e.ctrlKey || e.metaKey) {
          e.preventDefault()
          window.open(tileLinkEl.getAttribute('href'), '_blank')
        } else {
          tileLinkEl.click()
        }
      }
    }
  }

  return {
    init: () => {
      initTiles()
    },
  }
})()

export default LinkTile
